<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Status</b>
    </sui-card-content>
    <sui-card-content class="link" @click="actions.serviceUpdate ? onClick() : () => {}">
      <sui-loader class="blue" active centered inline size="huge" v-if="inProgress && !inQueue" />
      <i class="clock inverted circular blue big fitted icon" v-if="inQueue" />
      <i class="inverted circular big fitted icon" :class="[status.icon, status.color]" v-if="!inProgress" />
      <b>{{status.text}}</b>
      <div class="aside">
        <sui-button attached="left" size="mini" color="blue" v-if="service.process">
          <Timer :started="service.processStarted" :active="!service.lastResult" />
        </sui-button>
      </div>
    </sui-card-content>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="!actions.serviceUpdate" data-goal="SERVICE_PAGE_RECREATE" @click="recreate()" v-if="buttons.recreate">Redeploy</sui-button>
      <sui-button :disabled="!actions.serviceUpdate" data-goal="SERVICE_PAGE_RESTART" @click="restart()" v-if="buttons.restart">Restart</sui-button>
      <sui-button :disabled="!actions.serviceUpdate" data-goal="SERVICE_PAGE_START" @click="start()" v-if="buttons.start">Start</sui-button>
      <sui-button :disabled="!actions.serviceUpdate" data-goal="SERVICE_PAGE_STOP" @click="stop()" v-if="buttons.stop">Stop</sui-button>
      <sui-button :disabled="!actions.serviceUpdate" data-goal="SERVICE_PAGE_CANCEL" @click="cancelTask()" v-if="buttons.cancel">Cancel</sui-button>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ServiceStatusCard',
    props: {
      service: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['actionsById']),
      actions() {
        return this.actionsById[this.service.id]
      },
      status() {
        return this.service._status
      },
      isOnline() {
        return this.service._isOnline
      },
      isDeployed() {
        return this.service._isDeployed
      },
      inProgress() {
        return this.service._inProgress
      },
      inQueue() {
        return this.service._inQueue
      },
      buttons() {
        const methods = this.service.constructor.methods
        if (this.inProgress) {
          return {cancel: true}
        }
        if (!this.isDeployed) {
          return {recreate: methods.recreate}
        }
        const hasRestartingContainers = this.service._containers.some(container => container._isRestarting)
        const areContainersOffline = this.service._containers.every(container => container._isOffline)
        return {
          start: methods.start && (!this.isOnline && areContainersOffline),
          restart: methods.restart && (this.isOnline || hasRestartingContainers),
          stop: methods.stop && (this.isOnline || hasRestartingContainers),
        }
      },
    },
    methods: {
      recreate() {
        this.service.recreate().catch(error => {
          this.$emit('error', error.message)
        })
      },
      restart() {
        return this.$modals.confirm.open({
          text: 'You are going to restart the service.',
          callback: () => {
            this.service.restart().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      start() {
        return this.$modals.confirm.open({
          text: 'You are going to start the service.',
          callback: () => {
            this.service.start().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      stop() {
        return this.$modals.confirm.open({
          text: 'You are going to stop the service.',
          callback: () => {
            this.service.stop().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      cancelTask() {
        return this.$modals.confirm.open({
          text: 'You are going to cancel the process.',
          callback: () => {
            this.service.cancelTask().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      onClick() {
        if (!this.inProgress) {
          if (!this.isDeployed) {
            return this.recreate()
          }
          if (this.isOnline) {
            return this.restart()
          }
          if (!this.isOnline) {
            return this.start()
          }
        }
      },
    },
  }
</script>

<style scoped>
  .ui.inline.loader { display: inline-block!important; width: 1em!important; height: 1em!important; font-size: 4em!important; }
  .ui.inline.loader:before { width: 100%; height: 100%; left: 0; margin: 0; }
  .ui.inline.loader:after { width: 100%; height: 100%; left: 0; margin: 0; }
  .aside { position: absolute; right: 0; top: 5%; max-height: 90%; display: flex; flex-direction: column; align-items: flex-start; }
  .aside .button { padding: .4em!important; font-size: .8em!important; white-space: nowrap; }
</style>
